import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LanguageService } from '@mzic/mzic-services';

const normalizeLang = (lang: string | undefined): 'pt-br' | 'en' => {
  if (lang?.toLowerCase().startsWith('pt')) {
    return 'pt-br';
  }

  return 'en';
};

const buildCurrentPath = (routePath: string | undefined): string[] => {
  if (!routePath) {
    return ['home'];
  }

  return routePath
    .split('/')
    .map((segment) => segment.trim())
    .filter(Boolean);
};

export const languageGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const languageService = inject(LanguageService);
  const lang = normalizeLang(languageService.getBrowserLanguage());

  return router.createUrlTree(['/', lang, 'home'], {
    queryParams: route.queryParams,
    fragment: route.fragment || undefined,
  });
};

export const dynamicLanguageGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const languageService = inject(LanguageService);

  const hasLangParam =
    !!route.params?.['lang'] || !!route.parent?.params?.['lang'];

  if (hasLangParam) {
    return true;
  }

  const lang = normalizeLang(languageService.getBrowserLanguage());
  const currentPath = buildCurrentPath(route.routeConfig?.path);

  return router.createUrlTree(['/', lang, ...currentPath], {
    queryParams: route.queryParams,
    fragment: route.fragment || undefined,
  });
};
